import Form from 'react-bootstrap/Form';
import ColorsList from '../../src/Common'
import { setSuitPartsList } from '../redux/Slices/MainSlice';
import {  useDispatch } from 'react-redux';

 
 

 
function ColorsSelect(props) {

    let dispatch = useDispatch();

    const SetSpecificColor = (v,type) => {
        debugger
      
        let color = v.target.value ;
        let  selector =type;
        if(props.checkColor){

            props.checkColor(v.target.selectedIndex === 0 ? '' : color)
        }
       
     dispatch(setSuitPartsList({color,selector}))


	}

   

    return (
        <>
          <Form.Select className="" onChange={(v)=>SetSpecificColor(v,props.type)} disabled={props.disabled}>   
                        <option value="#FFFFFF">Select Color</option>
                        {ColorsList.map(x => 
                        x.value==props.selectedColor?
                            <option value={x.value}  selected={true}>{x.name}</option>
                            :
                            <option value={x.value}  selected={false}>{x.name}</option>
                            )}
                    </Form.Select>
        </>
    );
}

export default ColorsSelect;